export default __webpack_public_path__ + "static/media/transfer-epoint-step2.e4d0b132.png";